import styled from 'styled-components';
import React from 'react';


function App() {
  return (
    <div className="App">
      <div className="container" style={{ width: "60%", margin: "0 auto", minWidth: "300px", marginBottom: "3em" }}>
        <h1 style={{ fontSize: "3em" }}>Distribute Embeddable Python</h1>
        <div style={{ fontSize: '2em' }}>
        </div>
        <div>
          <div style={{ fontSize: '1.6em' }}>
            The Embeddable Python + pip + Libraries
          </div>
          <div>
            Distribute Embeddable Python is a tool available for using embeddable python with pip ecosystem. Off course the python is still portable.
          </div>
        </div>
        <div style={{ marginTop: "1.5em" }}>
          When you first download the Embeddable Python you find its size is small but doesn't even have pip.
          One of the benefits we enjoy when we use Python is a wealth of excellent libraries. 
          However, although we know how to use pip, 
          we don't know how to install pip 
          because the Python installed with the official installer already contains pip.
          This tool gives users the embeddable Python with pip and libraries installed with pip as an option.
        </div>
        <h2>Get Started</h2>
        <h3>Choice 1. Download embeddable python with pip installed</h3>
        <div>
          Download from <a href="https://github.com/europeanplaice/distribute-embeddable-python/releases">https://github.com/europeanplaice/distribute-embeddable-python/releases</a>
        </div>
        <h3>Choice 2. Make your own embeddable python with pip and libraries</h3>
        <div>
          <ol>
            <li>Install Rust from <a href="https://www.rust-lang.org/">https://www.rust-lang.org/</a></li>
            <li>Clone <a href="https://github.com/europeanplaice/distribute-embeddable-python">this repository</a> and change your current directory to this repo</li>
            <li>Build Rust and make an executable by running <code>cargo build --release</code></li>
            <li>The executable will be created at <code>./target/release/distribute_embeddable_python.exe</code></li>
            <li>Run the executable</li>
          </ol>
        </div>
        <h2>How to install libraries with the embeddable python and pip</h2>
        <div>
          Because PATH of the embeddable python or pip is not added, you can't call pip as you usually do like <code>pip install numpy</code>.<br/>
          Instead, you call pip from the path of python such as <code>python-3.11.0-embed-amd64\python.exe -m pip install numpy</code>
        </div>
        <h2>Repository</h2>
        <div>
          <a href="https://github.com/europeanplaice/distribute-embeddable-python">https://github.com/europeanplaice/distribute-embeddable-python</a>
        </div>
      </div>
    </div>
  );
}

export default App;
